import api from "src/api/axiosInstance";
import { setbrand } from "src/store/slices/brand-slice";
import { store } from "src/store/store";

export const fetchBrands = async () => {
  try {
    const response = await api.get(`/brands?page=1&limit=100`);
    if (response.data.status === 0) {
      store.dispatch(setbrand(response.data.data));
      return response.data.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching brands:", error);
    return [];
  }
};
